import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';
import { notifyPermissionDenied } from '../core/handleCallableError';

export const getFavoriteAuctions = async () => {
  const getFavoriteAuctionsFn = httpsCallable(functions, 'getFavoriteAuctionsNewV2');
  
  try {
    const result = await getFavoriteAuctionsFn();
    return result.data;
  } catch (error) {
    console.error('Error al obtener subastas favoritas:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};
